import type { PreviewPanelsApiState } from './types';

export const initialState: PreviewPanelsApiState = {
	// Configured when opening a panel.
	panel: null,
	width: 400,
	onOpen: () => {},
	onClose: () => {},
};
